import ServiceBrokerCaller from "./serviceBrokerCaller";

interface Parceiro {
  codParc?: number;
  nomeParc?: string;
}

interface FindStatusApiResponse {
  entidades?: {
    entidade?: unknown;
  };
}

interface OferecerContratacaoResponse {
  oferecerContratacao?: boolean;
}

interface GetConfResponse {
  config?: {
    config?: {
      expirationTime?: number;
    };
    isSubmitted?: boolean;
  };
}

export default class ErpUtils {
  private static PARCEIRO_CACHE: Parceiro | null = null;

  static async getParceiro() {
    try {
      if (this.PARCEIRO_CACHE) {
        return this.PARCEIRO_CACHE;
      }
      this.PARCEIRO_CACHE = await ServiceBrokerCaller.callService('ParceiroSP.getParceiro', {});
      return this.PARCEIRO_CACHE;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  static async findStatusApi(resourceId: string): Promise<boolean | null> {
    try {
      const cachedValue = this.getLocalStorageConfigExibicao(`V1:pql-found-jnm-webcom82-statusapi:${resourceId}`);
      if (cachedValue !== null) {
        return cachedValue;
      }

      const params = {
        entity: {
          name: "ContaBancaria",
          rowsLimit: 1,
          literalCriteria: {
            expression: {
            $: "STATUSAPI = 'S'",
            },
          },
        },
      };

      const response = await ServiceBrokerCaller.callService('crud.find', { requestBody: params }) as FindStatusApiResponse | null;
      
      console.warn('findStatusApi - response:', JSON.stringify(response));

      this.setLocalStorageSaveConfigExibicao(`V1:pql-found-jnm-webcom82-statusapi:${resourceId}`, response?.entidades?.entidade == null);
      return response?.entidades?.entidade == null;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  static async oferecerContratacao(resourceId: string, codUsuario: string): Promise<boolean> {
    try {
      const cachedValue = this.getLocalStorageConfigExibicao(`V1:plg-found-jnm-webcom82-oferecercontratacao:${resourceId + codUsuario}`);
      if (cachedValue !== null) {
        return cachedValue;
      }

      const response = await ServiceBrokerCaller.callService('found-jnm-webcom82@CredenciamentoSP.oferecerContratacao', {}) as OferecerContratacaoResponse | null;

      console.warn('oferecerContratacao - response:', JSON.stringify(response));

      const oferecerContratacao = response?.oferecerContratacao || false;

      this.setLocalStorageSaveConfigExibicao(`V1:plg-found-jnm-webcom82-oferecercontratacao:${resourceId + codUsuario}`, oferecerContratacao);
      return oferecerContratacao;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  static async getConfigExibicao(config: string, codUsuario: string): Promise<boolean> {
    try {
      const cachedValue = this.getLocalStorageConfigExibicao(config);
      if (cachedValue !== null) {
        return cachedValue;
      }

      const requestBody = {
        config: {
          chave: config,
          usuario: codUsuario,
          tipo: "T"
        }
      };

      const response = await ServiceBrokerCaller.callService('SystemUtilsSP.getConf', { requestBody }) as GetConfResponse | null;

      const expirationTime = response?.config?.config?.expirationTime;
      if (!expirationTime || (expirationTime && Date.now() > expirationTime)) {
        this.setLocalStorageSaveConfigExibicao(config, true);
        return true;
      } 
      
      this.setLocalStorageSaveConfigExibicao(config, false);
      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  static async isformSubmitted(): Promise<boolean> {
    try {
      const chave = 'V1:submitted.pqlfintech';
      const cachedValue = this.getLocalStorageConfigExibicao(chave);
      if (cachedValue !== null) {
        return cachedValue;
      }

      const requestBody = {
        config: {
          chave,
          usuario: '0',
          tipo: "T"
        }
      };
      const response = await ServiceBrokerCaller.callService('SystemUtilsSP.getConf', { requestBody }) as GetConfResponse | null;

      const isSubmitted = response?.config?.isSubmitted;

      if (isSubmitted) {
        this.setLocalStorageSaveConfigExibicao(chave, true);
        return true;
      }

      this.setLocalStorageSaveConfigExibicao(chave, false);
      return false;

    } catch (error) {
      console.error(error);
      return false;
    }
  }

  static async saveConfigExibicao(value: string, codUsuario: string): Promise<void> {
    try {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      const day = now.getDate();

      const targetMonthIndex = month + 1;
      let expirationDate = new Date(year, targetMonthIndex, day);

      if (expirationDate.getMonth() !== (targetMonthIndex % 12)) {
        expirationDate = new Date(year, targetMonthIndex + 1, 0); 
      }

      const expirationTime = expirationDate.getTime();
    
      const requestBody = {
        config: {
          chave: value,
          usuario: codUsuario,
          tipo: "T",
          config: {
            expirationTime
          }
        }
      };

      await this.callSaveConf(requestBody);
    } catch (error) {
      console.error(error);
    }
  }

  static async saveSubmittedForm(value: string): Promise<void> {

    const requestBody = {
        config: {
          chave: value,
          usuario: "0",
          tipo: "T",
          config: {
            isSubmitted: true
          }
        }
      };

      await this.callSaveConf(requestBody);
  }

  static async callSaveConf(requestBody): Promise<void> {
    await ServiceBrokerCaller.callService('SystemUtilsSP.saveConf', { requestBody });
    this.setLocalStorageSaveConfigExibicao(requestBody.config.chave, false);
  }

  static setLocalStorageSaveConfigExibicao(config: string, value: boolean): void {
    try {
      localStorage.removeItem(config);
      const date = new Date();
      date.setDate(date.getDate() + 1);
      const expirationTime = date.getTime();
      localStorage.setItem(config, JSON.stringify({ value, expirationTime }));
    } catch (error) {
      console.error(error);
    }
  }

  static getLocalStorageConfigExibicao(config: string): boolean | null {
    try {
      const cachedValue = localStorage.getItem(config);
      if(!cachedValue) return null;
      
      const { value, expirationTime } = JSON.parse(cachedValue);
      const expirationDate = new Date(expirationTime);

      if (Date.now() < expirationDate.getTime()) {
        console.warn('Usando valor em cache para', config, ':', value);
        return value;
      }
      
    } catch (error) {
      console.error(error);
    }
    return null;
  }

  static clearLocalStorageConfigItem(config: string): void {
    try {
      localStorage.removeItem(config);
    } catch (error) {
      console.error(error);
    }
  }
}